exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\nul.grid-menu[data-v-14808e64] {\r\n  display: -ms-grid;\r\n  display: grid;\r\n  -ms-grid-columns: (1fr)[3];\r\n      grid-template-columns: repeat(3, 1fr);\r\n  /* align-items: end; */\n}\nul.grid-menu > li[data-v-14808e64] {\r\n  width: auto;\n}\nul.grid-menu > li > a[data-v-14808e64] {\r\n  display: block;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-14808e64","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/components/home-page-components/grid-menu-items.component.vue
// module id = 551
// module chunks = 0